<script setup lang="ts">
/**
 * ADMIN-T013 — top-level layout. Renders Booting/BootstrapFailed/Reauthenticating
 * indicators or the Ready shell (top bar + side menu + main).
 */
import { computed } from 'vue';
import { RouterView } from 'vue-router';
import { useBootstrapState } from './bootstrap';
import TopBar from './layout/TopBar.vue';
import SideMenu from './layout/SideMenu.vue';
import ErrorBoundary from './errorBoundary/ErrorBoundary.vue';

const boot = useBootstrapState();
const isReady = computed(() => boot.state === 'Ready' || boot.state === 'AuthResolving');
</script>

<template>
  <div class="app-shell">
    <template v-if="boot.state === 'Idle' || boot.state === 'Booting' || boot.state === 'ConfigLoading' || boot.state === 'PermissionPriming'">
      <div class="boot-screen">
        <div
          class="spinner"
          aria-hidden="true"
        />
        <p>正在加载…（{{ boot.state }}）</p>
      </div>
    </template>

    <template v-else-if="boot.state === 'BootstrapFailed'">
      <div class="boot-screen error">
        <h2>系统初始化失败</h2>
        <p>{{ boot.error?.message ?? '未知错误' }}</p>
        <p>错误码：<code>{{ boot.error?.code ?? 'bootstrap_failed' }}</code></p>
        <p>请刷新页面重试；若问题持续，请联系系统管理员。</p>
      </div>
    </template>

    <template v-else-if="boot.state === 'Reauthenticating'">
      <div class="boot-screen">
        <p>登录已过期，正在重新认证…</p>
      </div>
    </template>

    <template v-else-if="isReady">
      <TopBar />
      <div class="body">
        <SideMenu />
        <main class="main">
          <ErrorBoundary>
            <RouterView />
          </ErrorBoundary>
        </main>
      </div>
    </template>
  </div>
</template>

<style scoped>
.app-shell {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  color: #0f172a;
  overflow: hidden;
}
.body {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
}
.main {
  flex: 1;
  overflow: auto;
  min-width: 0;
  background: #f6f8fb;
}
.boot-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 12px;
  text-align: center;
  color: #475569;
}
.boot-screen.error {
  color: #b91c1c;
}
.spinner {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid #cbd5e1;
  border-top-color: #2563eb;
  animation: spin 0.9s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
